<script lang="ts" setup>
import type { Component } from 'vue'
import { ElementalTypeEnum } from '~~/src/types/elemental'
import IconSnippetFolder from '~/components/Icon/SnippetFolder/index.vue'
import IconAutomationFolder from '~/components/Icon/AutomationFolder/index.vue'
import IconDocumentFolder from '~/components/Icon/DocumentFolder/index.vue'
import IconPromptFolder from '~/components/Icon/PromptFolder/index.vue'
import IconTableFolder from '~/components/Icon/TableFolder/index.vue'
import IconCourses from '~/components/Icon/Courses/index.vue'
import IconImageFolder from '~/components/Icon/ImageFolder/index.vue'
import IconFolder from '~/components/Icon/Folder/index.vue'

defineProps<{ type: ElementalTypeEnum | number }>()

const Icons: Record<ElementalTypeEnum | number, Component> = {
  [ElementalTypeEnum.Snippet]: IconSnippetFolder,
  [ElementalTypeEnum.Automation]: IconAutomationFolder,
  [ElementalTypeEnum.Document]: IconDocumentFolder,
  [ElementalTypeEnum.Prompt]: IconPromptFolder,
  [ElementalTypeEnum.Table]: IconTableFolder,
  [ElementalTypeEnum.Course]: IconCourses,
  [ElementalTypeEnum.Image]: IconImageFolder,
  [ElementalTypeEnum.List]: IconFolder,
}
</script>

<template>
  <component :is="Icons[type]" v-if="Icons[type]" />
  <IconFolder v-else />
</template>
